"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var pro_duotone_svg_icons_1 = require("@fortawesome/pro-duotone-svg-icons");
var react_i18next_1 = require("react-i18next");
var react_admin_1 = require("react-admin");
var MeatballMenu_module_css_1 = __importDefault(require("./MeatballMenu.module.css"));
var AccessControl_1 = __importDefault(require("./AccessControl"));
var types_1 = require("@/Types/types");
var PermissionContext_1 = require("./PermissionContext");
var MeatballMenu = function (props) {
    var _a, _b;
    var onManageResourceAccess = props.onManageResourceAccess, onManageGroupAccess = props.onManageGroupAccess, onDelete = props.onDelete, propResourceId = props.resourceId, propResourceName = props.resourceName, style = props.style, menuSx = props.menuSx, resourceType = props.resourceType;
    var _c = (0, react_1.useState)(null), menuAnchorElement = _c[0], setMenuAnchorElement = _c[1];
    var menuOpen = Boolean(menuAnchorElement);
    var t = (0, react_i18next_1.useTranslation)().t;
    var record = (0, react_admin_1.useRecordContext)();
    var groupId = (record === null || record === void 0 ? void 0 : record.presentation_group_id) || (record === null || record === void 0 ? void 0 : record.player_group_id);
    var groupName = ((_a = record === null || record === void 0 ? void 0 : record.presentation_group) === null || _a === void 0 ? void 0 : _a.name) || ((_b = record === null || record === void 0 ? void 0 : record.player_group) === null || _b === void 0 ? void 0 : _b.name);
    var resourceId = propResourceId || getResourceId(record, resourceType);
    var resourceName = propResourceName || (record === null || record === void 0 ? void 0 : record.name) || (record === null || record === void 0 ? void 0 : record.title);
    function getResourceId(record, resourceType) {
        switch (resourceType) {
            case types_1.ResourceType.PRESENTATION:
            case types_1.ResourceType.PLAYLIST:
                return record === null || record === void 0 ? void 0 : record.presentation_id;
            default:
                return record === null || record === void 0 ? void 0 : record.id;
        }
    }
    var handleClick = function (event) {
        event.stopPropagation();
        setMenuAnchorElement(event.currentTarget);
    };
    var handleClose = function (event) {
        event.stopPropagation();
        setMenuAnchorElement(null);
    };
    var handleMenuItemClick = function (onClick) {
        return function (event) {
            onClick(event);
            handleClose(event);
        };
    };
    var handleManageResourceAccess = function (event) {
        var id = resourceId || (record === null || record === void 0 ? void 0 : record.presentation_id);
        var name = resourceName || (record === null || record === void 0 ? void 0 : record.name);
        if (onManageResourceAccess && id && name) {
            onManageResourceAccess(id, name, "Resource");
        }
        handleClose(event);
    };
    var handleManageGroupAccess = function (event) {
        if (onManageGroupAccess && groupId && groupName) {
            onManageGroupAccess(groupId, groupName, "Group");
        }
        handleClose(event);
    };
    var permissionsNeeded = {
        edit: __spreadArray(__spreadArray(__spreadArray([
            { globalPerm: "global-".concat(resourceType.toLowerCase(), "s-write"), specificPerms: ["resource-write", "resource-group-write"] }
        ], (resourceType === types_1.ResourceType.EVENT ? [
            { globalPerm: "global-event-management-manager", specificPerms: ["resource-manager"] }
        ] : []), true), (resourceType === types_1.ResourceType.OAUTH2CLIENT ? [
            { globalPerm: "edit-api", specificPerms: [] }
        ] : []), true), (resourceType === types_1.ResourceType.METADATA ? [
            { globalPerm: "global-metadata-write", specificPerms: [] }
        ] : []), true),
        manageAccess: [
            { globalPerm: "edit-user-management", specificPerms: [] }
        ],
        duplicate: [
            { globalPerm: "global-".concat(resourceType.toLowerCase(), "s-manager"), specificPerms: ["resource-group-manager"] }
        ],
        delete: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
            { globalPerm: "global-".concat(resourceType.toLowerCase(), "s-manager"), specificPerms: ["resource-group-manager"] }
        ], (resourceType === types_1.ResourceType.FOLDER ? [
            { globalPerm: "global-media-manager", specificPerms: ["resource-manager"] }
        ] : []), true), (resourceType === types_1.ResourceType.MEDIA ? [
            { globalPerm: "global-media-write", specificPerms: ["resource-write"] }
        ] : []), true), (resourceType === types_1.ResourceType.EVENT ? [
            { globalPerm: "global-event-management-manager", specificPerms: ["resource-manager"] }
        ] : []), true), (resourceType === types_1.ResourceType.OAUTH2CLIENT ? [
            { globalPerm: "edit-api", specificPerms: [] }
        ] : []), true), (resourceType === types_1.ResourceType.METADATA ? [
            { globalPerm: "global-metadata-manager", specificPerms: [] }
        ] : []), true),
        view: [
            { globalPerm: "global-media-read", specificPerms: ["resource-read"] }
        ],
        details: [
            { globalPerm: "global-media-read", specificPerms: ["resource-read"] }
        ],
        download: [
            { globalPerm: "global-media-read", specificPerms: ["resource-read"] }
        ],
    };
    var hasPermission = function (permissionName, resourceId, folderPermissions) {
        if (resourceId === void 0) { resourceId = null; }
        if (folderPermissions === void 0) { folderPermissions = []; }
        if (folderPermissions.includes(permissionName)) {
            return true;
        }
        var userPermissions = (0, react_1.useContext)(PermissionContext_1.PermissionsContext).userPermissions;
        if (!userPermissions) {
            return false;
        }
        var hasPerm = userPermissions.some(function (permission) {
            var matchesResourceId = permission.resourceId === resourceId || permission.resourceType === "global";
            var matchesPermissionName = permission.name === permissionName;
            return matchesResourceId && matchesPermissionName;
        });
        return hasPerm;
    };
    var hasGlobalOrSpecificPermission = function (globalPerm, specificPerms, resourceId, folderPermissions) {
        if (folderPermissions === void 0) { folderPermissions = []; }
        var hasGlobal = hasPermission(globalPerm, null, folderPermissions);
        var hasSpecific = specificPerms.some(function (specificPerm) {
            var specificPermResult = hasPermission(specificPerm, resourceId, folderPermissions);
            return specificPermResult;
        });
        return hasGlobal || hasSpecific;
    };
    var hasPermissionForAction = function (actionPermissions, resourceId, folderPermissions) {
        if (folderPermissions === void 0) { folderPermissions = []; }
        var result = actionPermissions.some(function (_a) {
            var globalPerm = _a.globalPerm, specificPerms = _a.specificPerms;
            var permissionResult = hasGlobalOrSpecificPermission(globalPerm, specificPerms, resourceId, folderPermissions);
            return permissionResult;
        });
        return result;
    };
    var isPresentationOrPlaylist = function (props) {
        return (props.resourceType === types_1.ResourceType.PRESENTATION || props.resourceType === types_1.ResourceType.PLAYLIST);
    };
    var isPlayer = function (props) {
        return props.resourceType === types_1.ResourceType.PLAYER;
    };
    var isIntegration = function (props) {
        return props.resourceType === types_1.ResourceType.INTEGRATION;
    };
    var isFolder = function (props) {
        return props.resourceType === types_1.ResourceType.FOLDER;
    };
    var isMedia = function (props) {
        return props.resourceType === types_1.ResourceType.MEDIA;
    };
    var isEvent = function (props) {
        return props.resourceType === types_1.ResourceType.EVENT;
    };
    var isO2AuthClient = function (props) {
        return props.resourceType === types_1.ResourceType.OAUTH2CLIENT;
    };
    var isMetadata = function (props) {
        return props.resourceType === types_1.ResourceType.METADATA;
    };
    var isAppTemplate = function (props) {
        return props.resourceType === types_1.ResourceType.APPTEMPLATE;
    };
    var renderMenuItems = function () {
        var commonItems = [
            {
                textKey: "Manage resource access",
                onClick: handleManageResourceAccess,
                condition: !!onManageResourceAccess &&
                    resourceType !== types_1.ResourceType.MEDIA &&
                    hasPermissionForAction(permissionsNeeded.manageAccess, resourceId),
            },
            {
                textKey: "Manage group access",
                onClick: handleManageGroupAccess,
                condition: !!onManageGroupAccess && hasPermissionForAction(permissionsNeeded.manageAccess, resourceId),
            },
            (isMedia(props) || isFolder(props) ?
                {
                    textKey: "Delete",
                    onClick: function (e) {
                        e.stopPropagation();
                        onDelete && onDelete(resourceId);
                        handleClose(e);
                    },
                    condition: !!onDelete && hasPermissionForAction(permissionsNeeded.delete, resourceId, props.folderPermissions),
                }
                :
                    isAppTemplate(props) ?
                        {
                            textKey: "Delete",
                            onClick: function (e) {
                                e.stopPropagation();
                                onDelete && onDelete(resourceId);
                                handleClose(e);
                            },
                            condition: !!onDelete,
                        }
                        :
                            {
                                textKey: "Delete",
                                onClick: function (e) {
                                    e.stopPropagation();
                                    onDelete && onDelete(resourceId);
                                    handleClose(e);
                                },
                                condition: !!onDelete && hasPermissionForAction(permissionsNeeded.delete, resourceId),
                            }),
        ];
        if (isPresentationOrPlaylist(props)) {
            var presentationPlaylistItems = [
                {
                    textKey: "Edit",
                    onClick: function (e) {
                        e.stopPropagation();
                        props.onEdit && props.onEdit();
                        handleClose(e);
                    },
                    condition: !!props.onEdit && hasPermissionForAction(permissionsNeeded.edit, resourceId),
                },
                {
                    textKey: "Duplicate",
                    onClick: function (e) {
                        e.stopPropagation();
                        props.onDuplicate && props.onDuplicate(resourceId);
                        handleClose(e);
                    },
                    condition: !!props.onDuplicate && hasPermissionForAction(permissionsNeeded.duplicate, resourceId),
                },
            ];
            return __spreadArray(__spreadArray([], presentationPlaylistItems, true), commonItems, true);
        }
        else if (isPlayer(props)) {
            var playerItems = [
                {
                    textKey: "Edit",
                    onClick: function (e) {
                        e.stopPropagation();
                        props.onEdit && props.onEdit();
                        handleClose(e);
                    },
                    condition: !!props.onEdit && hasPermissionForAction(permissionsNeeded.edit, resourceId),
                },
            ];
            return __spreadArray(__spreadArray([], playerItems, true), commonItems, true);
        }
        else if (isIntegration(props)) {
            var integrationItems = [
                {
                    textKey: "Edit",
                    onClick: function (e) {
                        e.stopPropagation();
                        props.onEdit && props.onEdit();
                        handleClose(e);
                    },
                    condition: !!props.onEdit && hasPermissionForAction(permissionsNeeded.edit, resourceId),
                },
            ];
            return __spreadArray(__spreadArray([], integrationItems, true), commonItems, true);
        }
        else if (isFolder(props)) {
            return commonItems;
        }
        else if (isMedia(props)) {
            var mediaItems = [
                {
                    textKey: "View",
                    onClick: function (e) {
                        e.stopPropagation();
                        props.onView && props.onView(e, record);
                        handleClose(e);
                    },
                    condition: !!props.onView &&
                        hasPermissionForAction(permissionsNeeded.details, resourceId, props.folderPermissions),
                },
                {
                    textKey: "Download",
                    onClick: function (e) {
                        e.stopPropagation();
                        props.onDownload && props.onDownload();
                        handleClose(e);
                    },
                    condition: !!props.onDownload &&
                        hasPermissionForAction(permissionsNeeded.details, resourceId, props.folderPermissions),
                },
                {
                    textKey: "Details",
                    onClick: function (e) {
                        e.stopPropagation();
                        props.onDetails && props.onDetails(e);
                        handleClose(e);
                    },
                    condition: !!props.onDetails &&
                        hasPermissionForAction(permissionsNeeded.details, resourceId, props.folderPermissions),
                },
            ];
            return __spreadArray(__spreadArray([], mediaItems, true), commonItems, true);
        }
        else if (isEvent(props)) {
            var eventItems = [
                {
                    textKey: "Edit",
                    onClick: function (e) {
                        e.stopPropagation();
                        props.onEdit && props.onEdit();
                        handleClose(e);
                    },
                    condition: !!props.onEdit && hasPermissionForAction(permissionsNeeded.edit, resourceId),
                },
            ];
            return __spreadArray(__spreadArray([], eventItems, true), commonItems, true);
        }
        else if (isO2AuthClient(props)) {
            var oAuthClientItems = [
                {
                    textKey: "Edit",
                    onClick: function (e) {
                        e.stopPropagation();
                        props.onEdit && props.onEdit();
                        handleClose(e);
                    },
                    condition: !!props.onEdit && hasPermissionForAction(permissionsNeeded.edit, resourceId),
                },
            ];
            return __spreadArray(__spreadArray([], oAuthClientItems, true), commonItems, true);
        }
        else if (isMetadata(props)) {
            var metadataItems = [
                {
                    textKey: "Edit",
                    onClick: function (e) {
                        e.stopPropagation();
                        props.onEdit && props.onEdit();
                        handleClose(e);
                    },
                    condition: !!props.onEdit && hasPermissionForAction(permissionsNeeded.edit, resourceId),
                },
            ];
            return __spreadArray(__spreadArray([], metadataItems, true), commonItems, true);
        }
        else if (isAppTemplate(props)) {
            var appTemplateItems = [
                {
                    textKey: "Edit",
                    onClick: function (e) {
                        e.stopPropagation();
                        props.onEdit && props.onEdit();
                        handleClose(e);
                    },
                    condition: !!props.onEdit,
                },
            ];
            return __spreadArray(__spreadArray([], appTemplateItems, true), commonItems, true);
        }
        return commonItems;
    };
    var canPerformAnyAction = resourceId && renderMenuItems().some(function (item) { return item.condition; });
    return (react_1.default.createElement("div", { style: style }, canPerformAnyAction && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.IconButton, { "aria-label": "more", id: "long-button", "aria-controls": menuOpen ? "long-menu" : undefined, "aria-expanded": menuOpen ? "true" : undefined, "aria-haspopup": "true", onClick: handleClick, className: MeatballMenu_module_css_1.default.icon_button, "data-cy": "meatballMenuIcon" },
            react_1.default.createElement("span", { className: MeatballMenu_module_css_1.default.custom_icon_container }, menuOpen
                ? react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTimes, className: MeatballMenu_module_css_1.default.close_menu_icon })
                : react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_duotone_svg_icons_1.faCircleEllipsis, className: MeatballMenu_module_css_1.default.open_menu_icon }))),
        react_1.default.createElement(material_1.Menu, { id: "long-menu", anchorEl: menuAnchorElement, keepMounted: true, open: menuOpen, onClose: handleClose, anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" }, sx: __assign({ marginLeft: "-75px", width: "250px", borderRadius: "14px" }, menuSx) }, renderMenuItems().map(function (_a, index) {
            var textKey = _a.textKey, onClick = _a.onClick, permission = _a.permission, condition = _a.condition;
            return condition && (react_1.default.createElement(AccessControl_1.default, { optionalPermissions: permission, key: index },
                react_1.default.createElement(material_1.MenuItem, { onClick: function (e) { return handleMenuItemClick(onClick)(e); }, style: {
                        color: "var(--info-color)",
                        fontFamily: "Geomanist",
                        fontSize: "12px",
                    }, "data-cy": textKey === "Delete" ? "meatballMenuDeleteMenuItem" : undefined },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleRight, color: "var(--primary-color)", size: "1x", style: { marginRight: "5px" } }),
                    t(textKey))));
        }))))));
};
exports.default = MeatballMenu;
